export default {
  int: {
    min: -2147483648,
    max: 2147483647,
  },
  unsignedInt: {
    min: 0,
    max: 4294967295,
  },
  unsignedIntHalf: {
    min: 0,
    max: 2147483647,
  },
  smallInt: {
    min: -32768,
    max: 32767,
  },
  unsignedSmallInt: {
    min: 0,
    max: 65535,
  },
  tinyInt: {
    min: -128,
    max: 127,
  },
  unsignedTinyInt: {
    min: 0,
    max: 255,
  },
};
